exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".green{color:#228b22}.yellow{color:#ff8c00}.red{color:darkred}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-0c4b4885!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PriceAnalysis/all.vue
// module id = 842
// module chunks = 2